<div class="error-container">
    Errore durante la precedente attività
</div>
